import { ReactNode, useEffect } from 'react'
import { useCartButton } from 'hooks'

interface CartLayoutProps {
  children: ReactNode
}

export const CartLayout = ({ children }: CartLayoutProps) => {
  const { showCartButton, hideCartButton } = useCartButton()

  useEffect(() => {
    showCartButton()

    return () => {
      hideCartButton()
    }
  }, [hideCartButton, showCartButton])

  return children
}
